import fetchApiWrapperWithTimeout from './fetchApiWrapperWithTimeout';
import settings from '../config/settings';
import { RecommendedApplicationsClientIds } from './user';

export interface ApplicationData {
  "application_infos": Application[];
}

export interface Application {
  client_id: string;
  name: string,
  url: string,
  app_id: string,
  app_type: string,
  dip_app_type: string,
  mobile_app_info: MobileAppInfo[],
  uses_mfa: boolean,
  translations?: ItemTranslations
}

export interface ItemTranslations {
    description: string,
    language: string,
    login_text:string,
    name: string,
    published: boolean,
    signup_text: string
}

export interface MobileAppInfo {
  os: string,
  id?: string,
  deep_link: string
}

export interface ApplicationSlimInfo {
  app_id: string;
  client_id: string;
  name: string;
  translated_name: string;
  translated_description?: string;
  url: string;
  dip_app_type: string;
  hidden: boolean;
  mobile_app_info: MobileAppInfo[];
}

export interface UserApplicationsProfile {
  used_applications: ApplicationSlimInfo[];
  authorized_applications: ApplicationSlimInfo[];
  recommended_applications: ApplicationSlimInfo[];
  has_more_applications: boolean;
}

export const getApplication = (clientId: string, pageLanguage: string): Promise<Application> => {
  const requestHeaders = new Headers();
  requestHeaders.set('Content-Type', 'application/json-patch+json; charset=utf-8');
  requestHeaders.append('Accept-Language', pageLanguage);

  return fetchApiWrapperWithTimeout(`${settings.backend.endpoint}/applications/${clientId}`, {
    headers: requestHeaders,
    method: 'GET',
  }, (!Number.isNaN(settings.backend.timeout) && settings.backend.timeout) || 10000);
}

export const validateApplicationCallbackUri = (clientId: string, callbackUri: string): Promise<boolean> => {
  const requestHeaders = new Headers({
    'Content-Type': 'application/json-patch+json; charset=utf-8'
  });

  return fetchApiWrapperWithTimeout(`${settings.backend.endpoint}/applications/${clientId}/validate-callback`, {
    method: 'POST',
    headers: requestHeaders,
    body: JSON.stringify({ callback_uri: callbackUri }),
  }, (!Number.isNaN(settings.backend.timeout) && settings.backend.timeout) || 10000);
}

export const getApplicationByName = (clientName: string, pageLanguage: string): Promise<Application> => {

  const requestHeaders = new Headers();
  requestHeaders.set('Content-Type', 'application/json-patch+json; charset=utf-8');
  requestHeaders.append('Accept-Language', pageLanguage);

  return fetchApiWrapperWithTimeout(`${settings.backend.endpoint}/applications/${clientName}?idType=name`, {
    headers: requestHeaders,
    method: 'GET',
  }, (!Number.isNaN(settings.backend.timeout) && settings.backend.timeout) || 10000);
}

export const getApplicationData = (clientIds: RecommendedApplicationsClientIds, pageLanguage: string): Promise<ApplicationData> => {

  const requestHeaders = new Headers();
  requestHeaders.set('Content-Type', 'application/json-patch+json; charset=utf-8');
  requestHeaders.append('Accept-Language', pageLanguage);

  return fetchApiWrapperWithTimeout(`${settings.backend.endpoint}/applications?idType=client_id`, {
    body: JSON.stringify(clientIds),
    headers: requestHeaders,
    method: 'POST',
  }, (!Number.isNaN(settings.backend.timeout) && settings.backend.timeout) || 10000);
}

export const getUserApplicationsProfile = (accessToken: string, isMobile: boolean, pageLanguage: string): Promise<UserApplicationsProfile> => {
  const requestHeaders = new Headers({
    'Content-Type': 'application/json-patch+json; charset=utf-8',
    'Authorization': `BEARER ${accessToken}`,
    'Accept-Language': pageLanguage,
  });

  return fetchApiWrapperWithTimeout(`${settings.myDanfossAPI.endpoint}/users/me/applications?is_mobile=${isMobile}&include_all_app_types=true&include_hidden=true`, {
    headers: requestHeaders,
    method: 'GET',
  }, (!Number.isNaN(settings.backend.timeout) && settings.backend.timeout) || 10000);
}
